<template>
  <button
    v-if="name"
    type="button"
    class="btn btn-hover-animation"
  >
    <UIIconComponent
      v-if="icon"
      :icon="icon"
    />

    <span class="hide sm-show">{{ name }}</span>

    <span class="btn-title-wrap sm-hide">
      <span
        v-for="variant in ['out', 'in']"
        :key="variant"
        :class="['btn-title', `btn-title--${variant}`]"
        :aria-hidden="variant === 'in' ? 'true' : undefined"
      >
        <span
          v-for="(word, index) in words"
          :key="index"
          class="btn-title-word"
          :style="{ transitionDelay: `${index * 30}ms` }"
        >
          {{ word }}&nbsp;
        </span>
      </span>
    </span>
  </button>
</template>

<script setup lang="ts">
  const props = defineProps<{
    name: string
    icon?: string
  }>()

  // Duplicated into an "out" (visible) and "in" (hidden below) copy so the hover animation
  // can slide the visible words up while the hidden copy slides into their place
  const words = computed(() => {
    const name = props.name?.trim()
    return name ? name.split(/\s+/) : []
  })
</script>
